var map = {
	"./arcane.png": "1a84",
	"./black earth.png": "5750",
	"./black fire.png": "7bd4",
	"./black ice.png": "ddfb",
	"./black lightning.png": "4882",
	"./black water.png": "91c5",
	"./black wind.png": "716c",
	"./blood.png": "c476",
	"./blood_rune.png": "3137",
	"./blue fire.png": "2f4c",
	"./celestial.png": "4d41",
	"./cyclone.png": "4849",
	"./dragonfire.png": "02c3",
	"./earth.png": "ca14",
	"./earth2.png": "cd6c",
	"./earth_2.png": "8ee6",
	"./earth_rune.png": "1167",
	"./fire.png": "443e",
	"./fire_rune.png": "557b",
	"./frost.png": "df27",
	"./hellfire.png": "13df",
	"./hybrid.png": "6200",
	"./hydro.png": "4db7",
	"./ice.png": "61e3",
	"./ice_rune.png": "830f",
	"./immolation.png": "6358",
	"./lava.png": "eb4e",
	"./lightning.png": "a800",
	"./lightning_rune.png": "4481",
	"./magic.png": "3cff",
	"./neg energy.png": "e21b",
	"./nightmare.png": "de0d",
	"./nova.png": "a31e",
	"./poison.png": "7ae8",
	"./shadow.png": "4f01",
	"./shadowfire.png": "4600",
	"./shadowfrost.png": "06f3",
	"./sonic.png": "96af",
	"./spiritual.png": "050f",
	"./summon.png": "0f86",
	"./tectonic.png": "0469",
	"./verbalist.png": "68d4",
	"./water.png": "997d",
	"./water_rune.png": "ca66",
	"./wind.png": "6a94",
	"./wind_rune.png": "771c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f50";